import { render } from "./SettingHeader.vue?vue&type=template&id=b1f990e8&scoped=true"
import script from "./SettingHeader.vue?vue&type=script&lang=js"
export * from "./SettingHeader.vue?vue&type=script&lang=js"

import "./SettingHeader.vue?vue&type=style&index=0&id=b1f990e8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1f990e8"]])

export default __exports__